msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: da\n"
"Project-Id-Version: 5b236266dda1bdf711f2dec226a4db34\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Danish\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 5b236266dda1bdf711f2dec226a4db34\n"
"X-Crowdin-Project-ID: 574\n"
"X-Crowdin-Language: da\n"
"X-Crowdin-File-ID: 25408\n"

#. Suffix part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the ' | FINN.no' part, including the space at the beginning)
#. js-lingui-explicit-id
#: src/server/server.ts:225
msgid "page.title.suffix"
msgstr " | Mærke"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:230
#: src/server/pages/default-landing.tsx:117
msgid "content.card2.title"
msgstr "... Opret den nemt med AI"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:27
#: src/server/pages/images.ts:68
#: src/server/pages/images.ts:110
msgid "content.image.finn.intro2.alt"
msgstr "En hånd, som holder en smartphone, der viser et billede at en cremefarvet, strikket polosweater på en pink baggrund, mens den rigtige sweater kan ses liggende under telefonen."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:318
#: src/server/pages/default-landing.tsx:234
msgid "content.steps.step3.description"
msgstr "AI foreslår overskriften og beskrivelsen. Du skal blot tilføje pris og adresse, før du opretter annoncen."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:291
#: src/server/pages/default-landing.tsx:207
msgid "content.steps.step1.description"
msgstr "Vinkel, lyssætning og antal – Ai giver dig gode råd, når du opretter din annonce!"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:35
msgid "content.image.finn.intro3.alt"
msgstr "Nærbillede af skærmen på en smartphone, der viser en notifikation fra FINN-appen med en besked om, at pengene er på vej, og at der kan gå 2-5 hverdage, før de fremgår på brugerens konto."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:76
#: src/server/pages/images.ts:118
msgid "content.image.tori.intro3.alt"
msgstr "Nærbillede af skærmen på en smartphone (på en slørret baggrund med varme farvetoner og lys), der viser en notifikation fra Tori-appen med en besked om, at pengene vil fremgå på brugerens konto om 2-5 hverdage."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:43
msgid "content.image.finn.aiHelper.alt"
msgstr "Nærbillede af skærmen på en smartphone, der viser brugergrænsefladen for FINN's AI-assistent, hvori produktoplysninger såsom brand, type, størrelse og farve automatisk er blevet udfyldt, sammen med tekst, der forklarer, at brugeren kan redigere eventuelt forkerte oplysninger."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:84
#: src/server/pages/images.ts:126
msgid "content.image.tori.aiHelper.alt"
msgstr "Nærbillede af skærmen på en smartphone, der viser brugergrænsefladen for Toris AI-assistent, hvori produktoplysninger såsom brand, type og størrelse automatisk er blevet udfyldt, sammen med tekst, der forklarer, at brugeren kan redigere eventuelt forkerte oplysninger."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:19
#: src/server/pages/images.ts:60
#: src/server/pages/images.ts:102
msgid "content.image.finn.intro1.alt"
msgstr "En cremefarvet, strikket polosweater med stofmønstre, ribstrikket krave og to knapper, der ligger pænt foldet på en pink baggrund."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:313
#: src/server/pages/default-landing.tsx:229
msgid "content.steps.step3.title"
msgstr "Detaljer udfyldes automatisk"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:56
msgid "content.title"
msgstr "Har du penge på loftet?"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:208
#: src/server/pages/default-landing.tsx:95
msgid "content.card1.title"
msgstr "Find ting, du ikke bruger ..."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:51
msgid "content.image.finn.testimonial.alt"
msgstr "Portrætfoto af Vigdis"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:279
#: src/server/pages/default-landing.tsx:197
msgid "content.steps.title"
msgstr "Sådan fungerer AI-hjælperen"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:299
#: src/server/pages/default-landing.tsx:215
msgid "content.steps.step2.title"
msgstr "Lad AI finde den rette kategori"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:213
#: src/server/pages/default-landing.tsx:100
msgid "content.card1.description"
msgstr "Måske en flot jakke eller en gammel iPad? Tjen penge, mens andre nyder godt af dine brugte varer!"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:252
#: src/server/pages/default-landing.tsx:137
msgid "content.card3.title"
msgstr "Penge direkte ned i din lomme!"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:59
msgid "content.description"
msgstr "Det har aldrig været nemmere at sælge de ting, du ikke bruger! Opret din annonce på 2 minutter med FINN's nye AI-værktøj."

#. js-lingui-explicit-id
#: src/islands/create-item-button/create-item-button.tsx:43
msgid "button.createItem"
msgstr "Opret en annonce"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:326
#: src/server/pages/default-landing.tsx:242
msgid "content.steps.step4.title"
msgstr "Opret"

#. Main part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the 'Selg med AI' part)
#. js-lingui-explicit-id
#: src/server/server.ts:218
msgid "page.title.main"
msgstr "Sælg med AI"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:235
#: src/server/pages/default-landing.tsx:120
msgid "content.card2.description"
msgstr "Tag et foto af den vare du vil sælge, og lad AI hjælpe dig med titlen, beskrivelsen og kategorien."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:286
#: src/server/pages/default-landing.tsx:202
msgid "content.steps.step1.title"
msgstr "Tag de bedst mulige billeder"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:304
#: src/server/pages/default-landing.tsx:220
msgid "content.steps.step2.description"
msgstr "Billederne bliver løbende analyseret, og de ting, du sælger, bliver automatisk placeret i den rette kategori på FINN."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:257
#: src/server/pages/default-landing.tsx:142
msgid "content.card3.description"
msgstr "Pengene bliver indsat direkte på din konto, så snart køberen har betalt sikkert via FINN."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:329
#: src/server/pages/default-landing.tsx:245
msgid "content.steps.step4.description"
msgstr "Dette trin skal du selvfølgelig selv klare!"

